import * as React from 'react';

import ActionButton from 'components/buttons/action-button/ActionButton';
import { withModal } from 'components/modal/ModalHOC';

import SelectStorySnippetsModal from '../select-story-snippets-modal/SelectStorySnippetsModal';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./select-story-snippets-action-button.i18n.json'));

import { OnSelectCallback } from '../../types';

interface Props {
  campaignStartDate: string,
  deliverableId: number,
  text?: string,
  saveButtonText?: string,
  saveChangesOnClose?: boolean,
  selectedStorySnippets?: Array<string>,
  onSelect: OnSelectCallback
}

const OpenModalButton = withModal(ActionButton, {
  modalContent: SelectStorySnippetsModal,
  width: 'auto'
});

const SelectStorySnippetsActionButton = ({
  campaignStartDate,
  deliverableId,
  text,
  saveButtonText,
  selectedStorySnippets,
  saveChangesOnClose,
  onSelect
}: Props): JSX.Element => (
  <OpenModalButton
    modalContentProps={{
      campaignStartDate,
      deliverableId,
      saveButtonText,
      saveChangesOnClose,
      selectedStorySnippets,
      onSelect
    }}
  >
    {text ?? __t('select_story_snippets_action_button.button_text')}
  </OpenModalButton>
);

export default SelectStorySnippetsActionButton;
